export const COURSE = {
    GET_COURSE: "course/GET_COURSE",
    GET_USER_COURSES: "course/GET_USER_COURSES",
    GET_USER_COURSE: "course/GET_USER_COURSE",
    GET_USER_COURSE_REVIEW: "course/GET_USER_COURSE_REVIEW",
    GET_SEEN_LESSON_ITEM: "course/GET_SEEN_LESSON_ITEM",
    UNLOCK_LESSON_USER: "course/UNLOCK_LESSON_USER",
};
